import moment from 'moment';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

function get(name: string, prefix?: string) {
  return cookies.get(`${prefix ? `${prefix}.` : ''}${name}`);
}

function set(name: string, value: any, prefix?: string, daysExpires = 15) {
  if (value)
    cookies.set(`${prefix ? `${prefix}.` : ''}${name}`, value, {
      expires: moment().add(daysExpires, 'days').toDate(),
      sameSite: 'lax',
    });
  else remove(name, prefix);
}

function remove(name: string, prefix?: string) {
  cookies.remove(`${prefix ? `${prefix}.` : ''}${name}`);
}

const wsCookies = {
  get,
  set,
  remove,
};

export default wsCookies;
